import React, { useCallback, useEffect } from 'react'
import { useApp } from '../../../context/AppProvider'
import useFetch from '../../../hook/UseFetch'
import { isEmpty } from '../../../services/common'
import { Loader, Parser } from '../../common'

const CanHelpMeLocation = ({ block }) => {
    const { valueLocation } = useApp()
    const { data, api, loading } = useFetch()

    if (
        !(
            block.attributes &&
            block.attributes.pivot_local &&
            block.attributes.type === 'Local personnalisé sur SP'
        )
    ) {
        return null
    }

    const apiFetch = useCallback(() => {
        api.servicesGet({
            pivot_local: block?.attributes.pivot_local,
            insee_code: valueLocation.insee,
        })
    }, [valueLocation.insee])

    useEffect(() => {
        if (valueLocation.insee) {
            apiFetch()
        }
    }, [valueLocation.insee])

    useEffect(() => {
        if (data) {
            block.childrens = data
        }
    }, [data])

    if (loading) return <Loader />

    return !isEmpty(block?.childrens) && <Parser content_block={block?.childrens} />
}

export default CanHelpMeLocation
